var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMoneyCircle = function SvgMoneyCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45 24c0 11.598-9.402 21-21 21S3 35.598 3 24 12.402 3 24 3s21 9.402 21 21Zm-3 0c0-9.942-8.058-18-18-18S6 14.058 6 24s8.058 18 18 18 18-8.058 18-18Zm-12.461-4.477v.123a1.5 1.5 0 0 1-3 0v-.123c0-1.134-.92-2.055-2.055-2.055h-.515a1.522 1.522 0 0 1-.105 0h-.514a2.055 2.055 0 0 0-.952 3.877l4.426 2.318a5.056 5.056 0 0 1-1.408 9.449v1.76a1.5 1.5 0 0 1-3 0v-1.76a5.056 5.056 0 0 1-4.121-4.97v-.123a1.5 1.5 0 0 1 3 0v.123c0 1.135.92 2.055 2.055 2.055h1.134a2.055 2.055 0 0 0 .95-3.876l-4.425-2.318a5.056 5.056 0 0 1 1.408-9.449v-1.759a1.5 1.5 0 0 1 3 0v1.76a5.056 5.056 0 0 1 4.122 4.968Z",
    fill: "#0075C9"
  })));
};
export default SvgMoneyCircle;